module.exports = __webpack_public_path__ + "img/lang-en.f4f2e8a3.svg";